import './Footer.less';
import { Container } from 'semantic-ui-react';
import { POSImage, useEnvironment } from '@publicisgroupe/p-os-components';
import { t } from '../../utils/resources';
import { useThemes } from 'components/ThemesProvider/hooks/useThemes';

export const Footer = () => {
  const { settings } = useEnvironment();
  const themes = useThemes();

  const footerLogo = themes?.footerLogo;
  const footerImage = themes?.footerImage
    ? themes.footerImage
    : `${settings.cdnBaseUrl}/webframe/footer-bg.jpg`;
  const getCurrentYear = new Date().getFullYear();

  return (
    <footer id="webframe-footer">
      <div
        className="background-img"
        data-testid="background-img"
        style={{ backgroundImage: `url(${footerImage})` }}
      />
      <Container>
        <p className="rights">{`© ${getCurrentYear} ${t('Footer.ReservedRightsNote')}`}</p>
        <p className="powered-by">{t('Footer.PoweredbyText', true)}</p>
        <div className="footer-logos-section">
          <div className="footer-logo">
            <POSImage src="webframe/Publicis-Logo-White.png" className="default-logo" />
            {footerLogo && (
              <div className="theme-logo">
                <img src={footerLogo} alt="theme-logo" />
              </div>
            )}
          </div>
        </div>
        <p className="powered-by-description">{t('Footer.Description')}</p>
      </Container>
    </footer>
  );
};
